/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';

/**
 * CancelSubscription Input Action
 */
export class CancelSubscriptionInput implements Msdyn365.IActionInput {
    public SubBillBillingScheduleNumber: string;
    public SubBillLineNum: string;

    constructor(SubBillLineNum: string, SubBillBillingScheduleNumber: string) {
        this.SubBillBillingScheduleNumber = SubBillBillingScheduleNumber;
        this.SubBillLineNum = SubBillLineNum;
    }

    public getCacheKey = () => `CancelSubscription ${this.SubBillBillingScheduleNumber}  ${this.SubBillLineNum} ${new Date()}`;
    public getCacheObjectType = () => 'CancelSubscription';
    public dataCacheType = (): Msdyn365.CacheType => 'application';
}

export interface ICancelSubscriptionData {
    response: ICancelSubscriptionResult;
}

export interface ICancelSubscriptionResult {
    value: boolean;
}

const createInput = (args: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
    return new CancelSubscriptionInput('', '');
};

async function action(input: CancelSubscriptionInput, ctx: Msdyn365.IActionContext): Promise<ICancelSubscriptionData> {
    let result: ICancelSubscriptionResult = { value: false };

    await Msdyn365.sendRequest(
        `${ctx.requestContext.apiSettings.baseUrl}Commerce/TecTerminateSubscription`,
        'post',
        {
            subscription: {
                SubBillBillingScheduleNumber: input.SubBillBillingScheduleNumber,
                SubBillLineNum: input.SubBillLineNum
            }
        },

        { headers: { OUN: ctx.requestContext.apiSettings.oun, Authorization: `id_token ${ctx.requestContext.user.token}` } }
    ).then(res => {
        result = {
            value: (res?.data as ICancelSubscriptionResult).value
        };
    });
    return { response: result };
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<ICancelSubscriptionData>>action,
    id: 'CancelSubscription',
    input: createInput
});
